var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"alt":"Logo Racing Analytics","src":require("@/assets/images/logo.svg"),"width":"16"}})
}
var staticRenderFns = []

export { render, staticRenderFns }